import React from 'react';
import { motion } from 'framer-motion';
import { FiFileText, FiExternalLink } from 'react-icons/fi';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import GlowText from '../components/ui/GlowText';

const Simulator = () => {
  return (
    <div className="min-h-screen flex flex-col bg-dark-900">
      <Navbar />
      
      <main className="flex-grow pt-32 pb-20 px-6 relative">
        {/* Ambient background glow */}
        <div className="absolute top-0 right-1/4 w-[500px] h-[500px] bg-cyan-900/5 rounded-full blur-[120px] pointer-events-none" />
        
        <div className="max-w-7xl mx-auto">
          {/* Header Section */}
          <div className="mb-12">
            <GlowText as="h1" className="text-4xl md:text-6xl text-white mb-6">
              PROUT Income and Inequality Simulator
            </GlowText>
            <div className="space-y-4 max-w-3xl">
              <p className="text-lg text-gray-300 font-light leading-relaxed">
                This interactive simulator illustrates how income inequality can change under a PROUT-style economic policy.
                It models a simulated population and applies two simple rules: a guaranteed minimum income floor and a maximum income ceiling.
              </p>
              <p className="text-sm text-gray-500 italic">
                The simulator is an educational tool designed to make economic concepts visible and easier to understand. It does not predict real-world outcomes.
              </p>
            </div>
          </div>

          {/* Iframe Container */}
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="relative w-full rounded-2xl overflow-hidden border border-white/10 bg-black shadow-2xl"
          >
            <iframe 
              src="/prout-sim/" 
              className="w-full h-[75vh] md:h-[85vh] border-none"
              title="PROUT Income Simulator"
            />
          </motion.div>

          {/* Manual Section */}
          <div className="mt-16 p-8 rounded-2xl bg-white/[0.02] border border-white/5 max-w-2xl">
            <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
              <FiFileText className="text-cyan-400" />
              Simulator explanation
            </h2>
            <p className="text-gray-400 mb-6 leading-relaxed">
              For a simple explanation of how the simulator works, open the user manual.
            </p>
            <a 
              href="/prout-sim/prout-sim-manual.pdf" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-2 px-6 py-3 rounded-full bg-white/5 border border-white/10 text-white hover:border-cyan-400/50 hover:bg-white/10 transition-all duration-300 group"
            >
              <span>Open the simulator explanation (PDF)</span>
              <FiExternalLink className="text-cyan-400 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </a>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Simulator;